import renderComponent from './renderComponent'
import withTheme from './withTheme'

const renderWithTheme = Component => renderComponent(withTheme(Component))

export default renderWithTheme



// WEBPACK FOOTER //
// ../src/utils/renderWithTheme.js